import { Stage_Entity } from "entities/stage";
import { rhapsodyApi } from "../api/rhapsodyApi";

export const mercuryJobEndpoints = rhapsodyApi.injectEndpoints({
  endpoints: (build) => ({
    getMercuryJobStage: build.query<Stage_Entity, number>({
      query: (mercuryJobStageID) =>
        `missions/mercuryJobStage/${mercuryJobStageID}`,
      providesTags: ["mercuryJobStages"],
    }),
  }),
});

export const { useLazyGetMercuryJobStageQuery } = mercuryJobEndpoints;

export default mercuryJobEndpoints;
